export const getOrSetLevel = async ()=>{
    let level = 3; // Default to level 3 (Heading 4 level in Word, as levels are 0-indexed)
    await Word.run(async (context)=>{
        const customProps = context.document.properties.customProperties;
        customProps.load("items");
        await context.sync();
        const existingProp = customProps.items.find((p)=>p.key === "HeadingLevel");
        if (existingProp && Number.isInteger(Number(existingProp.value))) {
            level = Number(existingProp.value);
        } else {
            customProps.add("HeadingLevel", level);
            await context.sync();
        }
    });
    return level;
};
export const setLevel = async (level)=>{
    await Word.run(async (context)=>{
        const customProps = context.document.properties.customProperties;
        customProps.load("items");
        await context.sync();
        customProps.add("HeadingLevel", level.toString());
        await context.sync();
    });
};
